import appLayout from '../layouts/AppLayout.vue'
export default [
  // HOTEL
  {
    path: '/hotels/search/juniper',
    name: 'hotels-juniper',
    component: () => import('../views/hotels/juniper/agency/index.vue'),
    meta: { 
      layout: appLayout,
      mode: 'hotels'  
    }
  },
  {
    path: '/hotels/search/disney/juniper',
    name: 'hotels-disney-juniper',
    component: () => import('../views/hotels/juniper/agency/index.vue'),
    meta: { 
      layout: appLayout,
      mode: 'hotels-disney'  
    }
  }, {
    path: '/hotels/search/universal/juniper',
    name: 'hotels-universal-juniper',
    component: () => import('../views/hotels/juniper/agency/index.vue'),
    meta: { 
      layout: appLayout,
      mode: 'hotels-universal'  
    }
  },
  {
    path: '/hotels/reserve/juniper',
    name: 'hotels-reserve-juniper',
    component: () => import('../views/hotels/juniper/agency/reserve.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/hotels/search/juniper/universal',
    name: 'hotels-juniper-universal',
    component: () => import('../views/hotels/juniper/agency/index.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/hotels/search/juniper/disney',
    name: 'hotels-juniper-disney',
    component: () => import('../views/hotels/juniper/agency/index.vue'),
    meta: { layout: appLayout }
  }
]
